import { render, staticRenderFns } from "./standardDetail.vue?vue&type=template&id=e2edef92&scoped=true&"
import script from "./standardDetail.vue?vue&type=script&lang=ts&"
export * from "./standardDetail.vue?vue&type=script&lang=ts&"
import style0 from "./standardDetail.vue?vue&type=style&index=0&id=e2edef92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2edef92",
  null
  
)

export default component.exports